import ExcelFileImport, {
    EXCEL_DATA_TYPES,
} from '../../../GlobalComponents/ExcelFileImport/ExcelFileImport'
import { FileImportedResults } from '../Layout/FileImportedResults'
import { useState } from 'react'
import style from './LOBupload.module.scss'
import { ProgressBar } from '@progress/kendo-react-progressbars'
import { useApiUpload } from '../../Hooks/useApiUpload'

export const LOBupload = () => {
    const [fileData, setFileData] = useState([] as importData[])
    const [readingFileDone, setReadingFileDone] = useState(false)
    const { uploading, uploadDone, onUploadClick, progress, errorData } = useApiUpload()

    const onFileImported = (importedData: any) => {
        setFileData(importedData)
        setReadingFileDone(true)
    }

    const returnHome = () => {}
    return (
        <div>
            <div className={style.topSpan}>
                <span>Drop your file and then click on review to start the upload process</span>
            </div>
            {!uploadDone && !readingFileDone && (
                <ExcelFileImport
                    key={'excelFileImport'}
                    returnHeaderRowInResults={true}
                    onFileImported={onFileImported}
                    columnList={[
                        {
                            fieldName: 'VendorID',
                            fieldLabel: 'VendorID',
                            dataType: EXCEL_DATA_TYPES.String,
                            maxDataLength: 2,
                            required: true,
                        },
                        {
                            fieldName: 'LOBCode',
                            fieldLabel: 'LOBCode',
                            dataType: EXCEL_DATA_TYPES.String,
                            maxDataLength: 10,
                            required: true,
                        },
                    ]}
                />
            )}
            {readingFileDone && !uploadDone && (
                <>
                    <FileImportedResults
                        onUploadClick={() => onUploadClick(fileData)}
                        UploadData={fileData}
                        message='No errors found'
                        showButton={true}
                    />
                    <ProgressBar
                        value={progress}
                        style={{
                            width: '100%',
                            marginTop: '20px',
                            visibility: uploading ? 'visible' : 'hidden',
                            height: '20px',
                        }}
                        labelVisible={false}
                    />
                </>
            )}
            {readingFileDone && uploadDone && (
                <>
                    <FileImportedResults
                        onUploadClick={returnHome}
                        UploadData={errorData}
                        message='Complete'
                        showButton={false}
                    />
                </>
            )}
        </div>
    )
}
